export const forcedProfitDeterminationTypes: Record<string, string | null> = {
  soleProprietorship: null,
  companyUnderCivilLaw: null,
  registeredMerchant: null,
  openTradingCompany: null,
  limitedPartnership: null,
  trustFoundation: null,
  legalFoundation: null,
  limitedLiabilityCompanyGmbh: 'balance',
  limitedLiabilityCompanyUG: 'balance',
  publicCompany: 'balance',
  limitedLiabilityPartnership: 'balance',
  partnershipCompany: 'balance',
  privatePerson: 'none',
}
